import { DatePipe } from '@angular/common'
import { PropertyConverter } from 'angular2-jsonapi'

import { Transacao } from '../extrato/transacao.model'
import { Venda } from '../extrato/venda.model'
import { Recebimento } from '../extrato/recebimento.model'
import { Antecipacao } from '../extrato/antecipacao.model'

export class TransacaoConverter<T extends Transacao> implements PropertyConverter {
    static datePipe = new DatePipe('pt')

    static toModel<T extends Transacao>(construtor: new () => T, obj: any): T {
        if (obj instanceof construtor) {
            return obj
        }

        const model = new construtor()

        model.id = obj.id
        model.bandeira = obj.bandeira
        model.data = new Date(`${obj.data}T00:00:00`)
        model.empresa = obj.empresa
        model.estabelecimento = obj.estabelecimento
        model.taxaDaOperadora = obj.taxaDaOperadora
        model.tipoDeVenda = obj.tipoDeVenda
        model.valorBruto = obj.valorBruto
        model.valorLiquido = obj.valorLiquido

        if (model instanceof Venda) {
            model.cancelada = obj.cancelada
        }

        if (model instanceof Recebimento) {
            model.tipoDeOperacao = obj.tipoDeOperacao
            model.valorDeAjuste = obj.valorDeAjuste
        }

        if (model instanceof Antecipacao) {
            model.dataDaAntecipacao = new Date(`${obj.dataDaAntecipacao}T00:00:00`)
            model.taxaDaAntecipacao = obj.taxaDaAntecipacao
            model.valorDaAntecipacao = obj.valorDaAntecipacao
        }

        return model
    }

    static toJSON<T extends Transacao>(model: T) {
        const json: any = Object.assign({}, model)

        json.data = TransacaoConverter.datePipe.transform(model.data, 'y-MM-dd')

        if (model instanceof Antecipacao) {
            json.dataDaAntecipacao = TransacaoConverter.datePipe.transform(
                model.dataDaAntecipacao,
                'y-MM-dd'
            )
        }

        return json
    }

    constructor(private construtor: new () => T) {}

    mask(value: any) {
        return TransacaoConverter.toModel(this.construtor, value)
    }

    unmask(value: any) {
        return TransacaoConverter.toJSON(value)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/converters/transacao.converter.ts